










import Vue from 'vue'
import ChildCategories from '@/search/components/category/ChildCategories.vue'
import { getSubCategoryByName } from '@/search/services'
import { DisplayChildCategory } from '@/common/types'
import { SubCategory } from '@/search/types'
export default Vue.extend({
  components: {
    ChildCategories
  },
  props: {
    categoryName: {
      type: String,
      default: ''
    }
  },
  data(): {
    subCategories: DisplayChildCategory[]
  } {
    return {
      subCategories: []
    }
  },
  async created() {
    if (this.categoryName) {
      const { category } = await getSubCategoryByName(this.categoryName)
      if (category) {
        this.subCategories = ((category.subCategories || []) as SubCategory[]).map(item => {
          return {
            id: item.id,
            displayName: item.displayName,
            thumbnail: item.iconImage,
            alt: item.iconImageAlt || item.displayName,
            url: item.url
          }
        })
      }
    }
  }
})
